export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  inject: ["getFieldValue", "updateFieldValue", "registerInput"],

  mounted() {
    this.registerInput(this);
    // favor the objects data over the default data
    this.currentValue = this.getFieldValue(this.name) || this.defaultValue || null;

    // make an initial FieldValue update
  },
  data() {
    return {
      error: null,
      currentValue: null,
    };
  },
  methods: {
    updateError(error) {
      this.error = error;
    },
    onFocus() {
      this.updateFieldValue(this.name, this.currentValue);
    },
  },
  watch: {
    currentValue(newValue) {
      this.updateFieldValue(this.name, newValue);
    },
    error(newError) {
      this.$emit("update:error", newError);
    },
  },
};
